import { useData } from "./hooks/data"
import { buildListaEsperaSlides } from "./utils/slideBuilders"
import CarouselGroup from "./components/carousel-group"
import NoticesSection from "./components/notices-section/NoticesSection"
import Turno from "./components/turno/Turno"
import "./Disponibilidad.css"

function ListaEspera(): JSX.Element {
    const { loading, logo, img_promo_horizontal, img_promo_vertical, lista_espera, folio_turn } = useData()

    const slides = buildListaEsperaSlides({
        listaEspera: lista_espera,
        showEmptyState: true,
    })

    return (
        <div className="disp__screen">
            <div className="disp__content">
                <div className="disp__card-section">
                    <CarouselGroup>{slides}</CarouselGroup>
                </div>

                <NoticesSection
                    logo={logo}
                    loading={loading}
                    imgPromoH={img_promo_horizontal}
                    imgPromoV={img_promo_vertical}
                    showListaEsperaTitle={true}
                    folioTurn={folio_turn}
                />

                <Turno 
                    folioTurno={folio_turn} 
                    size="large" 
                    showDuration={10000} 
                    isModal={true}
                >
                    <span>Pregunta al personal por tu habitación.</span>
                </Turno>
            </div>
        </div>
    )
}

export default ListaEspera